import { HAND_JOINTS } from "./handPose";

// Babylon's RHS GLBs are authored for native WebXR joint transforms. Only names
// differ. Keep their bind matrices and weights intact; no per-thumb overrides.
export function bindHandModelJoints(model, side) {
  const suffix = side === "left" ? "L" : "R";
  const joints = HAND_JOINTS.map(name => {
    if (name === "wrist") return model.getObjectByName(`wrist_${suffix}`);
    const [finger, joint] = name.startsWith("thumb-")
      ? ["thumb", name.slice(6)] : name.split("-finger-");
    const bone = { "phalanx-proximal": "proxPhalanx", "phalanx-intermediate": "intPhalanx", "phalanx-distal": "distPhalanx" }[joint] || joint;
    return model.getObjectByName(`${finger === "pinky" ? "little" : finger}_${bone}_${suffix}`);
  });
  if (joints.some(bone => !bone?.isBone)) throw new Error(`Incomplete ${side} WebXR hand model`);
  joints.forEach((bone, i) => { bone.name = HAND_JOINTS[i]; });
  return joints;
}
